import React,{useState,useEffect} from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import { apiUrl } from "../commons/inFormTypes";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";

function Comment() {
  const [person, setPerson] = useState(0);
  const [Stchange, setstchange] = useState(false);
  const [comment, setComment] = useState("");
  const [seenFile, setSeenFile] = useState([]);
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate()

  useEffect(() => {
    if (userToken == null) {
      navigate("/");
    } else {
      const axios = require("axios");
      axios
        .post(apiUrl + "Get_ListComments", {
          TokenId: userToken,
        })

        .then((res) => {
          if (res.data.result === "true") {
            setSeenFile(res.data.data);
          } else {
          }
        })
        .catch(function (error) {
          if (error.response) {
            toast.error(error.response.data.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        });
    }
  }, [Stchange]);

  const submitHandler = () => {
    const axios = require("axios");
    axios
      .post(apiUrl + "Insert_Comments", {
        Comment: comment,
        Type: person,
        Type_Tittle: "",
        TokenId: userToken,
      })

      .then((res) => {
        if (res.data.result === "true") {
          if (Stchange){
            setstchange(false)
          }else {
            setstchange(true)
          }  
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        } else {
          toast.error(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
      .catch(function (error) {
        if (error.response) {
          toast.error(error.response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  }

  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={8} className="rgc-request p-4 rgc-profile ">
            <div className="d-flex rgc-title">
              <div className="rgc-title-point"></div>
              <h4>ثبت <span>نظرات و پیشنهادات</span></h4>
            </div>
            <Row className="justify-content-center">

              <Col xs={12} md={6} className="mb-3 ms-auto">
                <Form.Group>
                  <Form.Label>ارجاع به</Form.Label>
                  <Form.Select
                  className="rgc-select"
                  value={person}
                  onChange={(e) => setPerson(e.target.value)}
                >
                    <option value="7">پیمانکار</option>
                    <option value="8">سازمان</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col xs={12}>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                  <Form.Label>متن </Form.Label>
                  <Form.Control 
                  as="textarea" 
                  rows={3}
                  value={comment}
                  className="rgc-profile-input"
                  onChange={(e) => setComment(e.target.value)}
                  />
                </Form.Group>
              </Col>


              <Col xs={12} className="text-center mb-3">
                <Button className="rgc-orderreg-btn rgc-order-btn-sub"  onClick={submitHandler}>
                  ارسال
                </Button>
              </Col>

              {seenFile.map((data, index) => {
                    return (
                      <Col xs={12} key={index} className="rgc-driver-txt rgc-station-time my-2">
                      <Row className="justify-content-center">

                      <Col xs={12}  className="rgc-order-span text-end">
                              <span>تاریخ:</span>
                              <span>{data.Date}</span>
                        </Col>

                          <Col xs={12}  className="rgc-order-span text-end">
                              <span>ارجاع شده به:</span>
                              <span>{data.Type_Tittle}</span>
                          </Col>

                          <Col xs={12}  className="rgc-order-span text-end">
                            <span>متن:</span>
                            <span>{data.Comment}</span>
                          </Col>

                      </Row>                
                   </Col>
                    )})}

              
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Comment;
